import React from 'react'

import Counter from '../presentation/Counter'
import FlexGrid from '../structure/FlexGrid'
import IconText from '../presentation/IconText'
import Link from '../actions/Link'
import Panel from '../structure/Panel'
import SeparatorWrapper from '../helpers/SeparatorWrapper'
import { COLORS } from '@btime/constants'

export const IconsBarItem = ({ onClick, counter, alertNote, ...props }) => (
  <SeparatorWrapper weight={4}>
    <Link onClick={onClick}>
      <Counter value={counter} alertNote={alertNote}>
        <IconText left color={alertNote ? COLORS.purple : COLORS.dark3} {...props} />
      </Counter>
    </Link>
  </SeparatorWrapper>
)

const IconsBar = ({ children }) => (
  <Panel noPadding>
    <FlexGrid justify="space-around">{children}</FlexGrid>
  </Panel>
)

export default IconsBar
